export const DEFAULT_PAGE_CALLS = 20
